import { Link } from '@mui/material'

type RelatedModel = { id: number; completed_at?: string | null; user_id: number }

const FormSubmissionRelatedView = ({ model }: { model: RelatedModel }) => (
  <>
    <Link href={`/patients/${model.user_id}/forms/submissions/${model.id}`}>
      View {model.completed_at ? 'completed' : 'incomplete'} form
    </Link>
  </>
)

export default FormSubmissionRelatedView
